import { useMutation } from 'react-query';
import { API } from 'api';
import { toastPush } from 'modules';
import { useDispatch } from 'react-redux';

export interface IUpdatePromotionStatusData {
  payload: {
    pid?: string;
    paused?: boolean;
    otherActiveTickerId?: string;
  };
}

const updatePromotionStatusData = (payload: IUpdatePromotionStatusData['payload']) => {
  return API.put()(`api/admin/promotion/${payload.pid}/status`, payload);
};

export const useUpdatePromotionStatusData = () => {
  const dispatch = useDispatch();

  return useMutation(updatePromotionStatusData, {
    onSuccess: () => {
      dispatch(
        toastPush({
          code: 200,
          type: 'success',
          title: 'SUCCESS',
          body: 'toastPush.updatedSuccessful',
        })
      );
    },
  });
};
